class MobileSearchPanel extends HTMLElement {
  constructor() {
    super();
    this.readyTimer = null;
    this.initialized = false;
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    document.addEventListener('click', this.onDocumentClick);

    if (!this.setupStickyPanelObserver()) {
      const domObserver = new MutationObserver((_, obs) => {
        if (this.setupStickyPanelObserver()) obs.disconnect();
      });
      domObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  showOverlay() {
    const overlay = document.getElementById('search-results-overlay-mobile');
    if (!overlay) return;
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    overlay.style.display = 'block';
    void overlay.offsetHeight;
    overlay.classList.add('active');
  }

  hideOverlay() {
    const overlay = document.getElementById('search-results-overlay-mobile');
    if (!overlay) return;
    overlay.classList.remove('active');
    setTimeout(() => {
      if (!overlay.classList.contains('active')) {
        overlay.style.display = 'none';
      }
    }, 300);
  }

  lockScroll() {
    document.body.classList.add('search-open-no-scroll');
  }

  unlockScroll() {
    document.body.classList.remove('search-open-no-scroll');
  }

  closePanel() {
    if (this.readyTimer) {
      clearTimeout(this.readyTimer);
      this.readyTimer = null;
    }
    this.classList.remove('is-ready');
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    this.unlockScroll();
    this.hideOverlay();
  }

  togglePanel(triggerEl) {
    const isOpen = this.classList.contains('is-open');
    if (!isOpen && triggerEl) {
      const stickyHeader = document.querySelector('.sticky-header');
      const mainHeader = document.querySelector('main-header');
      if (stickyHeader && stickyHeader.contains(triggerEl) && !stickyHeader.contains(this)) {
        stickyHeader.appendChild(this);
      } else if (mainHeader && (!stickyHeader || !stickyHeader.contains(triggerEl)) && !mainHeader.contains(this)) {
        mainHeader.appendChild(this);
      }
    }
    this.classList.toggle('is-open', !isOpen);
    this.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    if (triggerEl) triggerEl.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (!isOpen) {
      this.lockScroll();
      this.showOverlay();
      this.readyTimer = setTimeout(() => {
        this.classList.add('is-ready');
        this.readyTimer = null;
      }, 310);
      setTimeout(() => {
        const input = this.querySelector('input[type="search"]');
        if (input) input.focus();
      }, 350);
    } else {
      this.closePanel();
    }
  }

  onDocumentClick(e) {
    const trigger = e.target.closest('[data-mobile-search-trigger]');
    if (trigger) {
      this.togglePanel(trigger);
      return;
    }
    if (this.classList.contains('is-open') && !this.contains(e.target)) {
      this.closePanel();
    }
  }

  // Sticky header is created by theme JS after our script runs, so we poll for it.
  setupStickyPanelObserver() {
    const stickyHeader = document.querySelector('.sticky-header');
    if (!stickyHeader) return false;
    const mainHeader = document.querySelector('main-header');
    new MutationObserver(() => {
      const isSticky = stickyHeader.classList.contains('show');
      if (isSticky && !stickyHeader.contains(this)) {
        stickyHeader.appendChild(this);
      } else if (!isSticky && mainHeader && !mainHeader.contains(this)) {
        this.closePanel();
        mainHeader.appendChild(this);
      }
    }).observe(stickyHeader, { attributes: true, attributeFilter: ['class'] });
    return true;
  }
}

if (!customElements.get('mobile-search-panel')) {
  customElements.define('mobile-search-panel', MobileSearchPanel);
}
